import * as React from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';

import SettingsActionCreators from 'bundles/account-settings/actions/SettingsActionCreators';
import SaveButton from 'bundles/account-settings/components/common/SaveButton';
import StatusMessage from 'bundles/account-settings/components/common/StatusMessage';
import SettingsConstants from 'bundles/account-settings/constants/SettingsConstants';

import _t from 'i18n!nls/account-settings';

import 'css!./__styles__/Password';

const { Fields, UpdateStates } = SettingsConstants;

export default class extends React.Component {
  static propTypes = {
    updateStatus: PropTypes.object,
    invalidFields: PropTypes.array,
  };

  state = {
    passwordsAreSame: false,
  };

  handleResetClick = () => {
    const passwords = {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentPassword' does not exist on type ... Remove this comment to see the full error message
      currentPassword: this.currentPassword.value,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'newPassword' does not exist on type 'def... Remove this comment to see the full error message
      newPassword: this.newPassword.value,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'retypedPassword' does not exist on type ... Remove this comment to see the full error message
      retypedPassword: this.retypedPassword.value,
    };

    if (passwords.currentPassword === passwords.newPassword) {
      this.setState(() => ({ passwordsAreSame: true }));
    } else {
      this.setState(() => ({ passwordsAreSame: false }));
      SettingsActionCreators.resetPassword(passwords);
    }
  };

  renderValidation(field: $TSFixMe) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'invalidFields' does not exist on type 'R... Remove this comment to see the full error message
    const { invalidFields } = this.props;

    if (_.includes(invalidFields, field)) {
      return <StatusMessage status={UpdateStates.FAILED} field={field} />;
    } else {
      return null;
    }
  }

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'updateStatus' does not exist on type 'Re... Remove this comment to see the full error message
    const { updateStatus } = this.props;
    const { passwordsAreSame } = this.state;
    return (
      <div className="rc-Password">
        <h2 className="section-title">{_t('Password')}</h2>

        <div className="horizontal-box wrap">
          <div className="settings-input-wrapper flex-1">
            <label htmlFor="settings-password-current">{_t('Current password')}</label>
            <input
              type="password"
              id="settings-password-current"
              ref={(node) => {
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentPassword' does not exist on type ... Remove this comment to see the full error message
                this.currentPassword = node;
              }}
              required
            />
            {this.renderValidation(Fields.PASSWORD)}
          </div>

          <div className="settings-input-wrapper flex-1">
            <label htmlFor="settings-password-new">{_t('New password')}</label>
            <input
              type="password"
              id="settings-password-new"
              ref={(node) => {
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'newPassword' does not exist on type 'def... Remove this comment to see the full error message
                this.newPassword = node;
              }}
              required
            />
          </div>

          <div className="settings-input-wrapper flex-1">
            <label htmlFor="settings-password-new-confirm">{_t('Retype password')}</label>
            <input
              type="password"
              id="settings-password-new-confirm"
              ref={(node) => {
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'retypedPassword' does not exist on type ... Remove this comment to see the full error message
                this.retypedPassword = node;
              }}
              required
            />
            {this.renderValidation(Fields.NEW_PASSWORD)}
          </div>
        </div>
        <div className="horizontal-box">
          <div>
            <SaveButton
              onClick={this.handleResetClick}
              text={_t('Change Password')}
              updating={updateStatus.state === UpdateStates.UPDATING}
            />
          </div>
          <div className="m-t-1s" data-unit="section-status-message">
            <StatusMessage status={passwordsAreSame ? UpdateStates.FAILED_SAME_PASSWORD : updateStatus.state} />
          </div>
        </div>
      </div>
    );
  }
}
